var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7627 35.2505C27.4075 35.2505 35.2261 27.4319 35.2261 17.7871C35.2261 8.14236 27.4075 0.32373 17.7627 0.32373C8.11794 0.32373 0.299316 8.14236 0.299316 17.7871C0.299316 27.4319 8.11794 35.2505 17.7627 35.2505Z",
    fill: "url(#paint0_radial_8000_59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7627 35.2505C27.4075 35.2505 35.2261 27.4319 35.2261 17.7871C35.2261 8.14236 27.4075 0.32373 17.7627 0.32373C8.11794 0.32373 0.299316 8.14236 0.299316 17.7871C0.299316 27.4319 8.11794 35.2505 17.7627 35.2505Z",
    fill: "url(#paint1_radial_8000_59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7627 35.2505C27.4075 35.2505 35.2261 27.4319 35.2261 17.7871C35.2261 8.14236 27.4075 0.32373 17.7627 0.32373C8.11794 0.32373 0.299316 8.14236 0.299316 17.7871C0.299316 27.4319 8.11794 35.2505 17.7627 35.2505Z",
    fill: "url(#paint2_radial_8000_59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5251 11.6886C25.5251 12.6071 24.7804 13.3518 23.8619 13.3518C22.9434 13.3518 22.1987 12.6071 22.1987 11.6886C22.1987 10.77 22.9434 10.0254 23.8619 10.0254C24.7804 10.0254 25.5251 10.77 25.5251 11.6886Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7632 23.3308C20.825 23.3308 23.3071 20.8487 23.3071 17.7869C23.3071 14.725 20.825 12.2429 17.7632 12.2429C14.7014 12.2429 12.2192 14.725 12.2192 17.7869C12.2192 20.8487 14.7014 23.3308 17.7632 23.3308ZM17.7632 21.1132C19.6003 21.1132 21.0895 19.624 21.0895 17.7869C21.0895 15.9497 19.6003 14.4605 17.7632 14.4605C15.926 14.4605 14.4368 15.9497 14.4368 17.7869C14.4368 19.624 15.926 21.1132 17.7632 21.1132Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67529 17.3436C6.67529 13.6177 6.67529 11.7547 7.4004 10.3317C8.03821 9.07987 9.05595 8.06214 10.3077 7.42432C11.7308 6.69922 13.5938 6.69922 17.3196 6.69922H18.2067C21.9325 6.69922 23.7955 6.69922 25.2185 7.42432C26.4704 8.06214 27.4881 9.07987 28.1259 10.3317C28.851 11.7547 28.851 13.6177 28.851 17.3436V18.2306C28.851 21.9565 28.851 23.8194 28.1259 25.2425C27.4881 26.4943 26.4704 27.512 25.2185 28.1498C23.7955 28.875 21.9325 28.875 18.2067 28.875H17.3196C13.5938 28.875 11.7308 28.875 10.3077 28.1498C9.05595 27.512 8.03821 26.4943 7.4004 25.2425C6.67529 23.8194 6.67529 21.9565 6.67529 18.2306V17.3436ZM17.3196 8.91679H18.2067C20.1062 8.91679 21.3974 8.91852 22.3956 9.00006C23.3679 9.0795 23.865 9.22347 24.2119 9.40019C25.0463 9.82541 25.7248 10.5039 26.15 11.3384C26.3268 11.6852 26.4708 12.1824 26.5502 13.1547C26.6317 14.1528 26.6335 15.444 26.6335 17.3436V18.2306C26.6335 20.1302 26.6317 21.4214 26.5502 22.4195C26.4708 23.3918 26.3268 23.889 26.15 24.2358C25.7248 25.0703 25.0463 25.7487 24.2119 26.1739C23.865 26.3507 23.3679 26.4947 22.3956 26.5741C21.3974 26.6556 20.1062 26.6574 18.2067 26.6574H17.3196C15.4201 26.6574 14.1289 26.6556 13.1308 26.5741C12.1585 26.4947 11.6613 26.3507 11.3145 26.1739C10.48 25.7487 9.80148 25.0703 9.37626 24.2358C9.19955 23.889 9.05557 23.3918 8.97614 22.4195C8.8946 21.4214 8.89287 20.1302 8.89287 18.2306V17.3436C8.89287 15.444 8.8946 14.1528 8.97614 13.1547C9.05557 12.1824 9.19955 11.6852 9.37626 11.3384C9.80148 10.5039 10.48 9.82541 11.3145 9.40019C11.6613 9.22347 12.1585 9.0795 13.1308 9.00006C14.1289 8.91852 15.4201 8.91679 17.3196 8.91679Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8000_59",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7732 26.5188) rotate(-55.3758) scale(31.8328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8000_59",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5258 36.4979) rotate(-65.1363) scale(28.1837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8000_59",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.57176 1.57112) rotate(-8.1301) scale(48.5119 10.3762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dc0ce8bba12cef3d1f5c75a6b31703c7.svg";
export { ForwardRef as ReactComponent };